import classNames from "classnames";
import * as React from "react";
import { MoneyDisplayHelper } from "../../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { Money } from "../../../../../../../../Wrap/Core/DataTypes/Money";

interface IIsaAllowanceOverviewChart {
    used?: Money;
    expected?: Money;
    remaining?: Money;
}

export const IsaAllowanceOverviewChart = (props: IIsaAllowanceOverviewChart) => {
    let total = 0;
    let usedPercentage = 0;
    let expectedPercentage = 0;
    let remainingPercentage = 0;
    let liftExpected = false; //Segment "Expected" might collapse with surrounding labels
    if (props.used) {
        total += props.used.Amount;
    }
    if (props.expected) {
        total += props.expected.Amount;
    }
    if (props.remaining) {
        total += props.remaining.Amount;
    }
    if (props.used) {usedPercentage = (100 * props.used.Amount) / total;}
    if (props.expected) {expectedPercentage = (100 * props.expected.Amount) / total;}
    if (props.remaining) {remainingPercentage = (100 * props.remaining.Amount) / total;}
    if (usedPercentage < 12 && expectedPercentage < 12) {liftExpected = true;}
    if (remainingPercentage < 12 && expectedPercentage < 12) {liftExpected = true;}

    return (
        <div className="isa-overview-chart container size-1000">
            <div className="ioc-bar">
                {usedPercentage > 0 && (
                    <div className="ioc-fill-used" style={{ width: `${usedPercentage}%` }}>
                        <span className="ioc-plabel">{usedPercentage.toFixed(2)}% Used</span>
                        <span className="ioc-figure">
                            <span>
                                {MoneyDisplayHelper.FromatMoneyDisplay(props.used?.Amount, props.used?.Currency)}
                            </span>
                        </span>
                    </div>
                )}
                {expectedPercentage > 0 && (
                    <div
                        className={classNames("ioc-fill-expected", { "is-lifted": liftExpected })}
                        style={{ width: `${expectedPercentage}%` }}
                    >
                        <span className="ioc-plabel">{expectedPercentage.toFixed(2)}% Expected</span>
                        <span className="ioc-figure">
                            <span>
                                {MoneyDisplayHelper.FromatMoneyDisplay(props.expected?.Amount, props.used?.Currency)}
                            </span>
                        </span>
                    </div>
                )}
                <div className="ioc-fill-remaining" style={{ width: `${remainingPercentage}%` }}>
                    <span className="ioc-plabel">{remainingPercentage.toFixed(2)}% Remaining</span>
                    <span className="ioc-figure">
                        <span>
                            {MoneyDisplayHelper.FromatMoneyDisplay(props.remaining?.Amount, props.used?.Currency)}
                        </span>
                    </span>
                </div>
            </div>
            <div className="ioc-axis" aria-hidden={true}>
                <span className="ioc-0">0%</span>
                <span className="ioc-25">25%</span>
                <span className="ioc-50">50%</span>
                <span className="ioc-75">75%</span>
                <span className="ioc-100">100%</span>
            </div>
        </div>
    );
};
